import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_pause",
  "use": "icon-icon_pause-usage",
  "viewBox": "0 0 44 44",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 44 44\" id=\"icon-icon_pause\"><g fill=\"none\" fill-rule=\"evenodd\"><circle stroke=\"#FFF\" stroke-width=\"3\" cx=\"22\" cy=\"22\" r=\"20.5\" /><path d=\"M18 14a1.5 1.5 0 0 1 1.5 1.5v13a1.5 1.5 0 0 1-3 0v-13A1.5 1.5 0 0 1 18 14Zm8 0a1.5 1.5 0 0 1 1.5 1.5v13a1.5 1.5 0 0 1-3 0v-13A1.5 1.5 0 0 1 26 14Z\" fill=\"#FFF\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol